import type { CodeNavRequestMessage } from '../../../../code-nav/handlers/types.js';

export function parseOptionalInt(raw: string | null): number | undefined {
  if (raw == null) return undefined;
  const parsed = parseInt(raw, 10);
  return Number.isInteger(parsed) ? parsed : undefined;
}

export function parseCodeNavParams(url: URL): Pick<CodeNavRequestMessage, 'path' | 'op' | 'line' | 'column'> {
  const path = url.searchParams.get('path') ?? '';
  const opRaw = url.searchParams.get('op')?.trim();
  const op =
    opRaw === 'references'
      ? 'references'
      : opRaw === 'symbols'
        ? 'symbols'
        : opRaw === 'definitions'
          ? 'definitions'
          : 'definition';
  const line = parseOptionalInt(url.searchParams.get('line')) ?? 1;
  const column = parseOptionalInt(url.searchParams.get('column')) ?? 0;
  return { path, op, line, column };
}

export function parseCodeNavPath(url: URL): string | null {
  const raw = url.searchParams.get('path')?.trim();
  if (!raw) return null;
  return raw.replace(/^\/+/, '') || '.';
}
